export default [
  "5 Star Hotel",
  "guest accommodation",
  "4 Star Hotel",
  "bed and breakfast",
  "3 Star Hotel",
  "resort",
  "2 Star Hotel",
  "hotel",
  "apartment",
  "motel",
  "hostel",
  "guesthouse",
  "campground",
  "b&b",
  "boutique hotel",
  "lodge",
  "ryokan",
  "bungalow",
  "residence",
  "cabin",
  "inn",
  "pension",
  "historic hotel"];


// WEBPACK FOOTER //
// ./assets/list/lodgingTypes.js